import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
  retry,
} from '@reduxjs/toolkit/query/react'
import { RetryOptions } from '@reduxjs/toolkit/dist/query/retry'
import { ENDPOINTS } from '@constants/index'
import { AuthToken, AuthTokenArgs } from '@typesApp/Session'
import { config } from '@config/config'
import { dbPrepareHeaders } from './prepareHeaders'

const MAX_RETRY_COUNT = 5

const authBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions
) => {
  // retry with backoff on 504 and 409
  const retryOptions: RetryOptions = {
    retryCondition: (error, args, extraArgs): boolean => {
      return (error.status === 409 || error.status === 504) && extraArgs.attempt <= MAX_RETRY_COUNT
    },
  }

  const dbBaseQuery = retry(
    fetchBaseQuery({
      baseUrl: config.getApiHost(),
      prepareHeaders: dbPrepareHeaders,
    }),
    retryOptions
  )

  return await dbBaseQuery(args, api, extraOptions)
}

export const authApi = createApi({
  reducerPath: 'auth',
  baseQuery: authBaseQuery,
  keepUnusedDataFor: 300,
  endpoints: builder => ({
    getAuthToken: builder.mutation<AuthToken, AuthTokenArgs>({
      query: body => ({
        url: ENDPOINTS.DIRECT_BILLING.AUTH_TOKEN,
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const { useGetAuthTokenMutation } = authApi
